module.exports = __webpack_public_path__ + "f68ae6bad762f2502abd1a1321a50fb1.pdf";